import axios from "axios";
import store from '../EcommerceStore';
import endpoints from './EcommerceEndpoints';
import '../local';
import { getRiyadhISOString } from "../Util";
import { IVR_JOURNEIES } from "../constants";

const win: any = window;
const apigeeBaseApiUrl = win["apigee_base_api_url"];
const apigeeBMBaseURL = win["apigee_bm_base_url"];
const apigeeBMXAPIKey = win["apigee_bm_x_api_key"];
const cemKey = win["cem_key"];
var otpToken = win["dapiToken"];
var reGenerateTokenUrl = win["regenerate_token_url"];
var serverURL = win["base_portal_url"];
var updateAPIURL = win["update_api_status_url"];
win.x_trans_id = "";

const createTransactionID = (isCorrelationId: boolean = false) => {
  let currentDateTime = new Date().toISOString().replace(/-|:|T/gi, '').replace('.', '').slice(2).slice(0, -1);
  return 'POR' + (isCorrelationId ? 'C' : '') + currentDateTime + '_' + Math.ceil(Math.random() * 100000);
}

// getCoreId function is to generate correlation id if xCoId is empty
const getCoreId: any = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let edata = urlParams.get('edata');
  let xCorelId: any = "";
  if (edata) {
    let decode = window.decodeURIComponent(atob(edata ? edata : ""));
    let params = JSON.parse(decode);
    xCorelId = params.xCoId;
    !!!win["x_cor_id"] && (win["x_cor_id"] = xCorelId);
    return xCorelId
  } else {
    xCorelId = createTransactionID(true);
    !!!win["x_cor_id"] && (win["x_cor_id"] = xCorelId);
    return xCorelId
  }
};

let config = {
  api: {
    baseURL: apigeeBMBaseURL,
    headers: {
      "Content-Type": "application/json",
      Authorization: "",
      "x-api-key": apigeeBMXAPIKey,
      "X-Correlation-Id": getCoreId(),
      "X-Source-Channel": "PORTAL",
      "X-Transaction-Id": ""
    },
  },
};

let otpConfig = {
  api: {
    baseURL: apigeeBaseApiUrl,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "",
      transactionId: "",
      channel: "PORTAL",
      "cem-key": cemKey
    },
  },
};

let AbsherConfig = {
  api: {
    baseURL: apigeeBaseApiUrl,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      channel: "PORTAL",
      "cem-key": cemKey
    },
  },
};

export const api = axios.create({ ...config.api });
export const otpApi = axios.create({ ...otpConfig.api });
export const absherApi = axios.create({ ...AbsherConfig.api });
export const simpleApi = axios.create();


const getJourneyName = (): string => {
  if (typeof window !== "undefined" && window.journeyName) {
    return window.journeyName;
  }

  try {
    const { journeyName, journey } = store.getState()?.SequenceManager || {};
    return journeyName || journey || "";
  } catch {
  }

  return "";
};

(function setupJourneyListener() {
  if (typeof window === "undefined") return;
  const onReady = (e: Event) => {
    const name = (e as CustomEvent).detail ?? "";
    api.defaults.headers.common["X-Journey-Name"] = name;
  };
  window.addEventListener("journeyName-ready", onReady);
})();

api.interceptors.request.use(
  async (conf: any) => {
    const saudiTime = getRiyadhISOString();
    conf.headers.Authorization = "Bearer " + win["clientToken"];
    conf.headers['X-Transaction-Id'] = createTransactionID();
    conf.headers['X-Timestamp'] = saudiTime;
    const name = getJourneyName();
    conf.headers["X-Journey-Name"] = name;
    if (conf.url.includes(endpoints.RETRIEVE_APPOINTMENTS) || conf.url.includes(endpoints.DELIVERY_COVERAGE_CHECK)) {
      conf.headers['x-channel-id'] = 'PORTAL';
    }
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

otpApi.interceptors.request.use(
  async (conf: any) => {
    conf.headers.Authorization = "Bearer " + otpToken;
    conf.headers.transactionId = createTransactionID();
    const name = getJourneyName();
    conf.headers["X-Journey-Name"] = name;
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

absherApi.interceptors.request.use(
  async (conf: any) => {
    const name = getJourneyName();
    conf.headers["X-Journey-Name"] = name;
    return conf;
  },
  (err) => {
    console.log("error in getting ", err);
  }
);

const getProductOfferByID = (productId: any) => {
  var query = `{
    getProductOfferByID(id: "`+ productId + `") {
      id {
        key
        version
      }
      isBundle
      name
      createdBy
      createdOn
      externalID
      productSpecification {
        id
        name
      }
      specCharValueUse {
        name
        specCharacteristicValue {
          value
          isDefault
        }
      }
      category {
        id
        name
        type
        parentId
        isAnchor
        isOfferContainer
        parentHierarchy {
          id
          name
          parentId
          isAnchor
          isOfferContainer
        }
      }
      productOfferingPrice {
        id
        code
        name
        externalID
        productOfferingTerm{
          duration{
              amount
              units
          }
        }
        processContext {
          id
          name
        }
        priceType
        price {
          unit
          value
        }
      }
      offerLabels{
        name
        description
        channel
    }
    }
  }`

  return api.post(endpoints.QUERY_GRAPHQL, { query: query });
}

const getExternalId = (productId: any) => {
  var query = `{
    getProductOfferByID(id: "`+ productId + `") {
      externalID
    }
  }`
  return api.post(endpoints.QUERY_GRAPHQL, { query: query });
}

const shoppingCart = () => {
  const { SequenceManager, ProductOffer } = store.getState();
  let journey = SequenceManager.journey;
  let productCharacteristics = ProductOffer?.productCharecteristics;
  let productOfferingPrice = ProductOffer?.productOfferingPrice;
  let itemTerm = productOfferingPrice?.[0]?.productOfferingTerm ?? null;
  let productCharacteristic = [];

  let contractLength = journey.split('_');
  if (contractLength?.[0] === "FTTH" && contractLength?.length > 1) {
    itemTerm = productOfferingPrice?.filter((productOffer: any) => {
      return (contractLength?.[1] === (productOffer?.productOfferingTerm?.[0]?.duration?.amount + ':' + productOffer?.productOfferingTerm?.[0]?.duration?.units))
    })?.[0]?.productOfferingTerm
  }
  for (let i = 0; i < productCharacteristics.length; i++) {
    if (productCharacteristics[i].name === 'SIM Type') {
      let defaultSimType = productCharacteristics[i].specCharacteristicValue.filter((sc: any) => sc?.isDefault === true)?.[0];
      if (defaultSimType) {
        productCharacteristic.push({ name: productCharacteristics[i].name, value: defaultSimType?.value });
      } else {
        productCharacteristic.push({ name: productCharacteristics[i].name, value: 'Not Required' });
        console.log("Default simType is not provided")
      }
    } else {
      productCharacteristic.push({ name: productCharacteristics[i].name, value: productCharacteristics[i].specCharacteristicValue?.[0].value })
    }
  }

  var data = {
    channel: SequenceManager?.channel,
    offerContainer: [{
      additionalAttributes: [{
        name: "orderType",
        value: SequenceManager?.orderType
      }],
      cartItem: [{
        action: 'Add',
        productOffering: {
          id: SequenceManager?.productKey,
          name: 'Product'
        },
        itemTerm: itemTerm,
        product: {
          productCharacteristic: productCharacteristic
        },
        quantity: 1
      }],
      category: SequenceManager?.category,
      processContext: 'ACQ'
    }],
    relatedParty: [
      {
        id: "Cust-01",
        "@referredType": "Customer"
      }
    ]
  }

  return api.post(endpoints.SHOPPING_CART + '?isNonPersistent=false', data);
}

const getProductCharacteristic = (characteristic: any) => {
  const { SequenceManager, ShoppingCart } = store.getState();
  let cartItems = ShoppingCart.shoppingCart.offerContainer?.[0].cartItem.filter((ci: any) => {
    return (ci.product.name === SequenceManager.selectedProduct)
  });
  let productCharacteristics = cartItems?.[0].product.productCharacteristic;
  let productChars = [];
  for (let i = 0; i < productCharacteristics.length; i++) {
    if (productCharacteristics[i].name === characteristic) {
      productChars.push({ name: productCharacteristics[i].name, value: productCharacteristics[i].value })
      break;
    }
  }
  return productChars;
}

const patchSignature = () => {
  const { ShoppingCart, ProductOfferingQualification } = store.getState();

  var data = {
    context: {},
    shoppingCartPatch: [{
      operation: "replace",
      path: "/signature",
      value: [ProductOfferingQualification.productOfferingQualification.signature]
    }]
  }

  return api.patch(endpoints.SHOPPING_CART + '/' + ShoppingCart.shoppingCart.id, data);
}

const patchSimType = (simType: string, orderType: string) => {
  const { ShoppingCart } = store.getState();
  let ocId = ShoppingCart.shoppingCart.offerContainer?.[0].id;
  let productOcId = ShoppingCart.shoppingCart.offerContainer?.[0].cartItem?.[0].id;

  var data = {
    context: {},
    shoppingCartPatch: [{
      operation: "patch",
      path: "/offercontainer/" + ocId + "/cartitem/" + productOcId + "/product/productcharacteristic",
      value: [{ "name": "SIM Type", "value": simType }]
    },
    {
      operation: "patch",
      path: "/offercontainer/" + ocId + "/cartitem/" + productOcId + "/product/productcharacteristic",
      value: [{ "name": "OrderType", "value": orderType }]
    },
    {
      operation: "patch",
      path: "/offercontainer/" + ocId + "/additionalAttribute/orderType",
      value: [{ "value": orderType }]
    }]
  }

  return api.patch(endpoints.SHOPPING_CART + '/' + ShoppingCart.shoppingCart.id, data);
}

const ChangeOfProcessContextSC = (processContextVal: string) => {
  const { ShoppingCart } = store.getState();
  const updatedOC = ShoppingCart?.shoppingCart.offerContainer.map((item: any) => {
    return item.processContext === "ACQ" ?
      { ...item, processContext: processContextVal } : item
  })
  var data = {
    existingShoppingCart: ShoppingCart?.shoppingCart,
    offerContainer: updatedOC
  }

  return api.put(endpoints.SHOPPING_CART + '/' + ShoppingCart.shoppingCart.id, data);
}

const patchUnpaidBills = () => {
  const { ShoppingCart, UnpaidBills } = store.getState();

  let ocId = ShoppingCart.shoppingCart.offerContainer?.[0].id;
  let unpaidBillsOcId = ShoppingCart.shoppingCart.offerContainer?.[0].cartItem.filter((ci: any) => {
    return (ci.product.name === 'Unpaid Bills')
  })?.[0].id;
  console.log(unpaidBillsOcId);

  var data = {
    context: {},
    shoppingCartPatch: [
      {
        operation: "delete",
        path: "/offercontainer/" + ocId + "/cartitem/" + unpaidBillsOcId,
        value: [{}]
      },
      {
        operation: "add",
        path: "/offercontainer/" + ocId + "/cartitem",
        value: [
          UnpaidBills.unpaidBillsResponse?.data?.ShoppingCartRequest?.cartItem?.[0]
        ]
      }
    ]
  }

  return api.patch(endpoints.SHOPPING_CART + '/' + ShoppingCart.shoppingCart.id, data);
}

const patchSecurityDeposit = () => {
  const { ShoppingCart, SecurityDeposit } = store.getState();

  let ocId = ShoppingCart.shoppingCart.offerContainer?.[0].id;
  let securityDepositOcId = ShoppingCart.shoppingCart.offerContainer?.[0].cartItem.filter((ci: any) => {
    return (ci.product.name === 'Security Deposit')
  })?.[0].id;

  var data = {
    context: {},
    shoppingCartPatch: [
      {
        operation: "delete",
        path: "/offercontainer/" + ocId + "/cartitem/" + securityDepositOcId,
        value: [{}]
      },
      {
        operation: "add",
        path: "/offercontainer/" + ocId + "/cartitem",
        value: [
          SecurityDeposit.fetchSecurityDepositResponse.ShoppingCartRequest.cartItem?.[0]
        ]
      }
    ]
  }

  return api.patch(endpoints.SHOPPING_CART + '/' + ShoppingCart.shoppingCart.id, data);
}

const qualifyProds = () => {
  const { SequenceManager } = store.getState();
  const { ShoppingCart } = store.getState();

  var data = {
    channel: SequenceManager.channel,
    context: {
      installedBase: {
        additionalCharacteristics: [],
        customer: {
          status: 'Active',
          account: [],
          agreement: [],
          contactMedium: []
        },
        productInventory: []
      },
      shoppingCart: ShoppingCart.shoppingCart
    },
    description: 'Qualification',
    instantSyncQualification: true,
    productOfferingQualificationItemContainer: [
      {
        category: SequenceManager.category,
        id: ShoppingCart.shoppingCart.offerContainer?.[0].id,
        processContext: 'ACQ',
        productOfferingQualificationItem: []
      }
    ],
    provideAlternative: true,
    provideUnavailabilityReason: true
  }

  return api.post(endpoints.QUALIFY_PRODUCTS, data);
}

const validateSCart = () => {
  const { ShoppingCart } = store.getState();
  return api.post(endpoints.SHOPPING_CART + '/' + ShoppingCart.shoppingCart.id + `/validate?isNonPersistent=false`);
}

const getShoppingCartById = (id: any) => {
  return api.get(endpoints.GET_SHOPPING_CART + '/' + id);
}

const updateAndValidateShoppingCart = (id: any) => {
  let data: any = {
    ShoppingCartId: id
  }
  return api.post(endpoints.UPDATE_VALIDATE_SHOPPING_CART, data);
}

const captData = () => {
  const { SequenceManager } = store.getState();
  const { ShoppingCart } = store.getState();
  const sectionsRequestBody = store.getState() as any;
  const sectionsVisited = SequenceManager.sectionsVisited;

  let sections = [];
  for (let i = 0; i < sectionsVisited.length; i++) {
    sections.push(sectionsRequestBody[sectionsVisited[i]].requestBody);
  }

  var data = {
    context: {
      channel: SequenceManager.channel,
      serviceability: {},
      shoppingCart: ShoppingCart.shoppingCart
    },
    sections: sections
  }

  return api.post(endpoints.CAPTURE_DATA, data);
}

const structure = () => {
  const { SequenceManager } = store.getState();
  const { ShoppingCart } = store.getState();

  var data = {
    context: {
      channel: SequenceManager.channel,
      serviceability: {},
      shoppingCart: ShoppingCart.shoppingCart
    }
  }
  return api.post(endpoints.CHECKOUT_STRUCTURE, data);
}

const getCheckoutBySCId = () => {
  const { ShoppingCart } = store.getState();
  return api.get(endpoints.GET_CHECKOUT_STRUCTURE + '/' + ShoppingCart.shoppingCart.id, {
    headers: {
      'validityToken': ShoppingCart.shoppingCart.validityToken
    }
  });
}

const fetchMsisdn = async (isVIP: boolean, newStack: any) => {
  const { SequenceManager } = store.getState();
  var data = {}

  if (isVIP) {
    data = {
      NewStack: newStack,
      JourneyName: SequenceManager.journeyName,
      resourceCapacityDemand: {
        resourceCapacityDemandAmount: "100",
        resourcePool: {
          id: 1,
          options: {
            vanity: "None",
            msisdn: getProductCharacteristic('Normal Number')?.[0].value,
            package: getProductCharacteristic('Technical Package Name')?.[0].value,
            version: 'V1'
          }
        },
        type: "phone number"
      }
    }
  } else {
    data = {
      NewStack: newStack,
      JourneyName: SequenceManager.journeyName,
      resourceCapacityDemand: {
        resourceCapacityDemandAmount: "100",
        resourcePool: {
          id: 1,
          options: {
            vanity: "None",
            msisdn: getProductCharacteristic('Normal Number')?.[0].value,
            package: ""
          }
        },
        type: "phone number"
      }
    }
  }
  return api.post(endpoints.GET_MSISDN, data);
  // return api.get('http://localhost:3001/availableMsisdn');
};

const reserveMsisdn = (reservedNumber: any, newStack: any) => {

  const { ShoppingCart, SequenceManager } = store.getState();
  var data = {
    JourneyName: SequenceManager.journeyName,
    reservationItem: [
      {
        NewStack: newStack,
        cartId: ShoppingCart.shoppingCart.id,
        orderType: SequenceManager.orderType,
        quantity: 1,
        appliedCapacityAmount: {
          resource: [
            {
              id: reservedNumber,
              name: "MSISDN",
              type: "PhoneNumber"
            }
          ]
        }
      }
    ]
  }

  return api.post(endpoints.RESERVE_MSISDN, data);
  // return api.get('http://localhost:3001/reserveMsisdn'); 
};

const getTccEligibility = (personId: any, nationality: any, requestType: any, customerConsent: any) => {
  const { SequenceManager } = store.getState();
  let data = {
    JourneyName: SequenceManager.journeyName,
    requestType: requestType,
    IdType: personId.charAt(0) === "1" ? "Saudi National ID" : "IQAMA",
    personId: personId,
    nationality: nationality,
    subscriptionType: getProductCharacteristic('Subscription Type')?.[0].value,
    msisdnType: getProductCharacteristic('MSISDN')?.[0].value,
    packageName: getProductCharacteristic('Technical Package Name')?.[0].value,
    customerConsent: customerConsent === true ? "true" : ""
  }
  return api.post(endpoints.TCC_ELIGIBILITY_CHECK, data);
  // return api.get('http://localhost:3001/tccEligibilityCheck');
}

const initiateOtp = (customerId: any) => {
  const { SequenceManager } = store.getState();
  var data = {
    JourneyName: SequenceManager.journeyName,
    OrderId: SequenceManager.orderId,
    CustomerId: customerId,
    Language: "en",
    Reason: "To conform payment"
  }
  return api.post(endpoints.INITIATE_OTP, data);
};

const validateOtp = (customerId: any, transactionId: any, verificationCode: any) => {
  const { SequenceManager } = store.getState();
  var data = {
    JourneyName: SequenceManager.journeyName,
    CustomerId: customerId,
    TransactionId: transactionId,
    VerificationCode: verificationCode
  }
  return api.post(endpoints.VALIDATE_OTP, data);
};

const getCustomerRelatedAccount = (personId: any) => {
  const { SequenceManager } = store.getState();
  const IdTypeValue = personId.charAt(0) === "1" ? "Saudi National ID" : "IQAMA";
  return api.get(endpoints.GET_CUSTOMER_RELATED_ACCOUNT + `?id=${personId}&idType=${IdTypeValue}&JourneyName=${SequenceManager.journeyName}`);
  // return api.get('http://localhost:3001/customerRelatedInquiry');
}

const getUnpaidBills = (personId: any, newStack: any) => {
  const { ShoppingCart, SequenceManager } = store.getState();
  let data = {
    JourneyName: SequenceManager.journeyName,
    CartId: ShoppingCart.shoppingCart.id,
    OrderType: "GSM",
    CustomerIdType: personId.charAt(0) === "1" ? "Saudi National ID" : "IQAMA",
    CustomerId: personId,
    NewStack: newStack
  }
  return api.post(endpoints.UNPAID_BILLS, data);
  // return api.get('http://localhost:3001/unpaidBills');
}

const getDeposit = (personId: any, bandWidth: any) => {
  const { ShoppingCart, SequenceManager } = store.getState();
  const plan = getProductCharacteristic('Technical Package Name')?.[0].value;
  let data = {
    JourneyName: SequenceManager.journeyName,
    CartId: ShoppingCart.shoppingCart.id,
    IDDocNumber: personId,
    IDDocType: personId.charAt(0) === "1" ? "Saudi National ID" : "IQAMA",
    Package: plan,
    Bandwidth: bandWidth
  }
  return api.post(endpoints.GET_SECURITY_DEPOSIT, data);
  // return api.get('http://localhost:3001/securityDeposit');
}

const mapDeliveryCheck = (lat: any, lon: any, city: any) => {
  var data = {
    city,
    packageSize: 'simcard',
    lat,
    lon
  }

  return api.post(endpoints.DELIVERY_COVERAGE_CHECK, data);
  // return api.post("http://localhost:3001" + endpoints.DELIVERY_COVERAGE_CHECK, data);
}

const getMainAndAroundODB = (lat: any, lng: any) => {
  let data = {
    "latitude": lat,
    "longitude": lng,
    "range": 100
  }

  return api.post(endpoints.GET_MAIN_AND_AROUND_ODB, data, {
    headers: {
      "x-channel-id": "PORTAL"
    }
  });
}

const generateOrder = (cartId: any, journeyName: any, simSwapPhoneNumber?: any) => {
  const { SequenceManager } = store.getState();
  let data: any= {
    JourneyName: journeyName,
    shoppingCartId: cartId,
  };
  if (SequenceManager.journeyName === "PreSSA") {
    return api.post(endpoints.GENERATE_ORDER_PRESSA, data);
  } else if (SequenceManager.journeyName === "Sim SWAP_eSIM" || SequenceManager.journeyName === "Sim SWAP_SIM") {
       data.msisdn = simSwapPhoneNumber;  
      return api.post(endpoints.GENERATE_ORDER_SIMSWAP, data);
  } else {
    return api.post(endpoints.GENERATE_ORDER, data);
  }

  // return api.get('http://localhost:3001/postProductOrder');
}

const getSimDetails = (NewStack: any) => {
  const { ShoppingCart, SequenceManager } = store.getState();
  let data = {
    NewStack: NewStack,
    JourneyName: SequenceManager.journeyName,
    SIMType: "Digital SIM",
    cartId: ShoppingCart.shoppingCart.id,
    orderType: SequenceManager.orderType
  }
  return api.post(endpoints.GET_SIM_DETAILS, data);
  // return api.get('http://localhost:3001/getEsim');
}

const tccRegisterApi = (IAMToken: any, requestType: any, getSimIccid: any, getSimImsi: any, msisdnNumber: any, idNumber: any, Nationality: any, payType: any, appToken: any, exceptionFlag: any, newStack: any) => {
  const { ShoppingCart, SequenceManager } = store.getState();
  let data = {
    JourneyName: SequenceManager.journeyName,
    RequestType: requestType,
    IAMToken: IAMToken,
    iccid: getSimIccid,
    imsi: getSimImsi,
    MSISDN: msisdnNumber,
    Nationality: Nationality,
    PayType: payType ? payType : getProductCharacteristic('TCCPackageType')?.[0].value,
    msisdnType: getProductCharacteristic('MSISDN')?.[0].value,
    IdType: idNumber.charAt(0) === "1" ? "Saudi National ID" : "IQAMA",
    IdNumber: idNumber,
    cartId: ShoppingCart.shoppingCart.id,
    orderType: SequenceManager.orderType,
    IAMAppToken: appToken,
    exceptionFlag: exceptionFlag,
    NewStack: newStack
  }
  return api.post(endpoints.TCC_REGISTRATION, data);
  // return api.get('http://localhost:3001/tccRegistration');
}

const getQrCode = (orderId: any,customerId:string) => {
  const { SequenceManager } = store.getState();
  let data = {
    JourneyName: SequenceManager.journeyName,
    OrderId: orderId,
    CustomerId: customerId
  }
  return api.post(endpoints.GET_QR_CODE, data);
}

const getEmailService = (orderId: any, email: any,customerId:any) => {
  const { SequenceManager } = store.getState();
  let data = {
    JourneyName: SequenceManager.journeyName,
    OrderId: orderId,
    RecipientEmail: email,
    CustomerId: customerId
  }
  return api.post(endpoints.EMAIL_SERVICE, data);
}
const getAllPlanDetails = (externalIds: any) => {
  var query = `{
        getProductOffersByExternalIDs(externalIds: [`+ externalIds + `]) {
          id {
            key
          }
          externalID
          name
          attachment {
            id
            name
            url
          }
          offerLabels{
            name
            description
            channel
        }
        }
      }`

  return api.post(endpoints.QUERY_GRAPHQL, { query: query });
}

const ftthFeasibilityCheck = (odb: any, bandwidth: any, seekerID: any) => {
  const { SequenceManager } = store.getState();
  let data = {
    OrderId: SequenceManager.orderId,
    ODBID: odb,
    Bandwidth: bandwidth,
    SeekerID: seekerID
  }
  return api.post(endpoints.FTTH_FEASIBILITY_CHECK, data);
}

const getAppointments = (odb: any, startDate: any, endDate: any, provider: any, typeOfService: any, bandWidth: any, city: any, district: any, region: any) => {
  const { SequenceManager } = store.getState();
  const appointmentEndPoint = provider.toLowerCase() !== 'mobily' ?
    endpoints.GET_APPOINTMENTS_NON_MOBILY : endpoints.GET_APPOINTMENTS;
  var data: any = {
    JourneyName: SequenceManager.journeyName,
    OrderId: SequenceManager.orderId,
    ODB: odb,
    Provider: provider,
    TypeOfService: typeOfService,//"Fibernet Provider",
    PreferredStartDate: startDate,
    PreferredEndDate: endDate
  }
  if (provider.toLowerCase() !== 'mobily') {
    Object.assign(data, { Bandwidth: bandWidth }, { DISTRICT: district }, { CITY: city }, { REGION: region });
  }
  console.log('----------- GET APPOINTMENTS -----------');
  return api.post(appointmentEndPoint, data);
}

const reserveAppointment = (odb: any, slotId: any, provider: any, startDate: any, endData: any) => {
  const { SequenceManager } = store.getState();
  const appointmentEndPoint = provider.toLowerCase() !== 'mobily' ?
    endpoints.RESERVE_APPOINTMENT_NON_MOBILY : endpoints.RESERVE_APPOINTMENT;
  var data: any = {
    JourneyName: SequenceManager.journeyName,
    OrderId: SequenceManager.orderId,
    SlotId: slotId,
    ODB: odb
  }
  if (provider.toLowerCase() !== 'mobily') {
    Object.assign(data, { Provider: provider }, { PreferredEndDate: endData }, { PreferredStartDate: startDate });
  }
  return api.post(appointmentEndPoint, data);
}

const customerDetailsApi = (MSISDN: any) => {
  const { SequenceManager } = store.getState();
  return api.get(endpoints.GET_CUSTOMER_DETAILS + `?MSISDN=${MSISDN}&JourneyName=${SequenceManager.journeyName}`);
  // return api.get('http://localhost:3001/accountByMsisdn');
}

const simswapCustomerDetailsApi = (MSISDN: any) => {
  const { SequenceManager } = store.getState();
  return api.get(endpoints.GET_CUSTOMER_DETAILS + `?MSISDN=${MSISDN}&JourneyName=${SequenceManager.journeyName}`);
}

const createOrder = () => {
  return api.get(endpoints.CREATE_ORDER_ID);
}

const fetchOdbDetails = (ODBID: any, provider: any) => {
  return api.get(endpoints.GET_ODB_DETAILS + `?ODBID=${ODBID}&Provider=${provider}`);
}

const FamilyPlanCheckApi = (idValue: any, packageId: any) => {
  const { SequenceManager } = store.getState();
  let data = {
    JourneyName: SequenceManager.journeyName,
    CustomerType: "Postpaid",
    FamilyLineActType: getProductCharacteristic('Family Line Act Type')?.[0].value, //"Master",
    CustomerIdType: idValue.charAt(0) === '1' ? "Saudi National ID" : "IQAMA", //"IQAMA",
    customerIdValue: idValue, //"2020910800",
    packageId: packageId, //"2098"
  }
  return api.post(endpoints.FAMILY_PLAN_CHECK, data);

}

const ValidateSimApi = (serialNumber: any, puk1Number: any) => {
  const { ShoppingCart, SequenceManager } = store.getState();
  const externalID = ShoppingCart.shoppingCart.offerContainer?.[0].cartItem?.[0].productOffering.externalId;
  let data = {
    JourneyName: SequenceManager.journeyName,
    SIMNumber: serialNumber,
    PUK1: puk1Number,
    CartId: ShoppingCart.shoppingCart.id,
    PackageName: getProductCharacteristic('Technical Package Name')?.[0].value,
    PackageId: externalID
  }
  return api.post(endpoints.VALIDATE_SIM, data);
  // return api.get('http://localhost:3001/simValidation'); 
}

const deliverySendOtp = (number: any, modId: any, lang: any, otpLength: any, isNumeric: any) => {
  const { SequenceManager } = store.getState();
  console.log('modId', modId)
  
  let data = {
    version: "v1",
    journey: SequenceManager?.journeyName === 'PreSSA' ? "PRESSA" : "COMMON",
    operation: "SEND_OTP",
    language: lang,
    extraInfo: [
      {
        "key": "ACCOUNT_NUMBER",
        "value": number,
      },
      {
        "key": "OTP_LENGTH",
        "value": otpLength
      },
      {
        "key": "IS_NUMERIC",
        "value": isNumeric
      },

    ]
  }
  return api.post(endpoints.DELIVERY_SEND_CEM_OTP, data);
  // return api.get('http://localhost:3001/dapiInitiateOtp');
}

const mnpSendOtp = (number: any, selectedProductLabel: any, lang: any, otpLength: any, isNumeric: any) => {
  let data = {
    version: "v1",
    journey: "MNP_ESIM",
    operation: "SEND_OTP",
    language: lang,
    extraInfo: [
      {
        key: "ACCOUNT_NUMBER",
        value: number,
      },
      {
        key: "OTP_LENGTH",
        value: otpLength
      },
      {
        key: "IS_NUMERIC",
        value: isNumeric
      },
      {
        key: "PARAM1",
        value: number
      },
      {
        key: "PARAM2",
        value: selectedProductLabel
      },
    ]
  }
  return api.post(endpoints.DELIVERY_SEND_CEM_OTP, data);
}

const simSwapSendOtp = (number: any, modId: any, email: any, verifyValue: any, date: any, lang: any, otpLength: any, isNumeric: any) => {
  let data = {
    msisdn: number,
    moduleId: modId,
    language: lang,
    otpLength: otpLength,
    isNumeric: isNumeric,
    verification: verifyValue,
    emailAddress: email,
    dynamicParams: [number, date]
  }
  return otpApi.post(endpoints.DELIVERY_SEND_OTP, data);
}

const simSwapResendOtp = (hashCode: any, verification: any) => {
  const { SequenceManager } = store.getState();
  let data = {
    hashCode: hashCode,
    language: SequenceManager.lang.toUpperCase(),
    otpLength: "4",
    isNumeric: "Y",
    verification: verification
  }
  return otpApi.put(endpoints.DELIVERY_RESEND_OTP, data);
}
const simSwapValidateOtp = (otp: any, hashCode: any) => {
  let data = {
    otp: otp,
    hashCode: hashCode
  }
  return otpApi.put(endpoints.DELIVERY_VALIDATE_OTP, data);
  //  return api.get('http://localhost:3001/dapiValidateOtp');
}

const deliveryValidateOtp = (otp: any, hashCode: any) => {
  let data = {
    operation: "VALIDATE_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: hashCode
      },
      {
        key: "OTP",
        value: otp
      }
    ]
  }
  return api.put(endpoints.DELIVERY_VALIDATE_CEM_OTP, data);
  // return api.get('http://localhost:3001/dapiValidateOtp');
}


const rSendOtp = (hashCode: any) => {
  let data = {
    operation: "RESEND_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: hashCode
      }
    ]
  }
  return api.put(endpoints.DELIVERY_RESEND_CEM_OTP, data);
}

const mobilyOtpSend = (customerId: any, msisdn: any, otpType: any, productLabel: any,
  technicalName: any, journeyName: any, nationalityCode: any, tccIdType: any, fecEncrypted: any, currentOperator: any, orderMSISDN: any) => {
  const { ShoppingCart, SequenceManager } = store.getState();

  let data = {
    CustomerId: customerId,   // New field added
    MSISDN: msisdn,
    FECEncrypted: fecEncrypted,
    SAN: "",
    OTPType: otpType,
    OTPStatus: "",
    PackageCommercialName: productLabel, // commercialName arabic and english
    PackageName: technicalName, // Technical Package name
    Language: SequenceManager.lang.toUpperCase() === "EN" ? "English" : "Arabic",
    CartId: ShoppingCart.shoppingCart.id,
    JourneyName: journeyName,
    PersonIdType: tccIdType,
    Nationality: nationalityCode,
    CurrentOperator: currentOperator,
    OrderMSISDN: orderMSISDN
  };
  return api.post(endpoints.MOBILY_OTP_INITIATE, data);
  // return api.get('http://localhost:3001/eaiGenerateOtp');
}

const mobilyOtpValidate = (requestId: any, msisdn: any, otp: any, journeyName: any) => {
  const { ShoppingCart } = store.getState();
  let data = {
    ServiceRequestID: requestId,
    MSISDN: msisdn,
    OTP: otp,
    CartId: ShoppingCart.shoppingCart.id,
    JourneyName: journeyName
  }
  return api.post(endpoints.MOBILY_OTP_VALIADTE, data);
  // return api.get('http://localhost:3001/eaiValidateOtp');
}

const mobilyOtpResend = (orderId: any, requestId: any, journeyName: any) => {
  const { ShoppingCart } = store.getState();

  let data = {
    OrderId: orderId,
    ServiceRequestID: requestId,
    CartId: ShoppingCart.shoppingCart.id,
    JourneyName: journeyName
  };
  return api.post(endpoints.MOBILY_OTP_REGENERATE, data);
}

const byPassVerification = () => {
  const url = `/digital/v1/data/mappings?contextId=CTX_PORTAL&catalogKey=PORTAL_CONFIG`;
  return absherApi.get(url);
};

const eSimValidation = (IdNumber: any, journeyName: any) => {
  const { ShoppingCart } = store.getState();

  let data = {
    JourneyName: journeyName,
    IDNumber: IdNumber,
    CartId: ShoppingCart.shoppingCart.id
  };
  return api.post(endpoints.ESIM_VALIDATION, data);
  // return api.get('http://localhost:3001/eSimValidation');
  // return api.get('https://run.mocky.io/v3/a0a587ea-9d1c-4c77-968f-d872c1fc8a34');  //eSIM activation allowed success
  // return api.get('https://run.mocky.io/v3/1fb2817a-1814-464b-8e6a-42a83c094e2c');  //eSIM activation Not-allowed success
};

const paymentInitiateApiCall = () => {
  const { ShoppingCart, SequenceManager } = store.getState();

  let data = {
    version: "v2",
    journey: SequenceManager.journeyName,
    operation: "INITIATE-AUTHORIZE",
    paymentProcessor: "MPGS",
    language: SequenceManager.lang.toLowerCase(),
    extraInfo: [
      {
        key: "SHOPPING_CART_ID",
        value: ShoppingCart.shoppingCart.id
      }
    ]
  };
  return api.post(endpoints.INITIATE_PAYMENT, data, { headers: { "cem-key": cemKey } });
  // return api.get('http://localhost:3001/initiatePayment');
}

const ecomPaymentInitiateApi = () => {
  const { ShoppingCart, SequenceManager } = store.getState();

  let data = {
    version: "v2",
    journeyName: SequenceManager.journeyName,
    operation: "INITIATE-AUTHORIZE",
    paymentProcessor: "MPGS",
    language: SequenceManager.lang.toLowerCase(),
    extraInfo: [
      {
        key: "SHOPPING_CART_ID",
        value: ShoppingCart.shoppingCart.id
      }
    ]
  };
  return api.post(endpoints.INITIATE_PAYMENT_ECOM, data, { headers: { "cem-key": cemKey } });
  // return api.get('http://localhost:3001/initiatePayment');
}

const ecomEsimPaymentInitiateApi = () => {
  const { ShoppingCart, SequenceManager } = store.getState();

  let data = {
    version: "v2",
    journeyName: SequenceManager.journeyName,
    operation: "INITIATE-AUTHORIZE",
    paymentProcessor: "MPGS",
    language: SequenceManager.lang.toLowerCase(),
    extraInfo: [
      {
        key: "SHOPPING_CART_ID",
        value: ShoppingCart.shoppingCart.id
      }
    ]
  };
  return api.post(endpoints.INITIATE_PAYMENT_ECOM_ESIM , data, { headers: { "cem-key": cemKey , "X-Journey-Name": SequenceManager.journeyName }});
   //return api.get('http://localhost:3001/newInitiatePayment');
}


const retrieveAppointments = () => {
  const { DeliveryDetails, SequenceManager, ShoppingCart } = store.getState();
  const packageName = ShoppingCart.shoppingCart.offerContainer?.[0].cartItem.filter((ci: any) => {
    return (ci.product.name === SequenceManager.selectedProduct)
  })?.[0].product.productCharacteristic.filter((pc: any) => {
    return (pc.name === 'Technical Package Name')
  });
  const packageSize = packageName?.[0]?.value?.toUpperCase() === 'RAQI' ? 'Pressa-RAQI' : `Pressa-${SequenceManager.planType}`;
  const data: any = {
    serviceType: "bullet",
    packageSize,
    lat: DeliveryDetails.requestBody.steps?.[0].fields?.[5]?.value?.toString(),
    lon: DeliveryDetails.requestBody.steps?.[0].fields?.[6]?.value?.toString()
  }
  console.log('----------- DELIVERY APPOINTMENTS -----------');
  return api.post(endpoints.RETRIEVE_APPOINTMENTS, data);
  // return api.get('http://localhost:3001/retrieveslots');
}

const cemSimSwapSendOtp = (number: any, idNumber: any, lang: any, emailVerification: boolean) => {
  const { SequenceManager } = store.getState();
  let data = {

    version: "v1",
    journey: "LOGIN",
    operation: "QUICK_LOGIN",
    language: lang,
    extraInfo: [
      {
        key: "ACCOUNT_NUMBER",
        value: number
      },
      {
        key: "ACCOUNT_TYPE",
        value: "MSISDN"
      },
      {
        key: "ID_NUMBER",
        value: idNumber
      },
      ...(
        IVR_JOURNEIES.includes(SequenceManager.journey) && SequenceManager.isIVRRequired
          ? [{ key: "SUB_JOURNEY", value: emailVerification ? "QUICK_LOGIN_ESIM_SWAP_EMAIL" : "QUICK_LOGIN_ESIM_SWAP" }]
          : []
      ),
      {
        key: "LOGIN_TYPE",
        value: "QUICK"
      }
    ]
  }
  return api.post(endpoints.CEM_INITIATE_OTP, data, { headers: { 'cem-key': win["cem_key"] } });
  // return api.get('http://localhost:3001/cemOTPInitiate');
}
const ivrCallbackStatus = (ivrRefId: string) => {
  let data = {
    "operation": "IVR_CALL_BACK_STATUS",
    "extraInfo": [
      {
        "key": "IVR_REF_ID",
        "value": ivrRefId
      }
    ]
  }
  return api.post(endpoints.IVR_CALL_BACK_STATUS, data, { headers: { 'cem-key': win["cem_key"] } });
  //  return api.get('http://localhost:3001/callbackStatus');
}
const tccCemBffSendOtp = (number: any, idNumber: any, lang: any, nationality: any) => {
  let data = {

    version: "v1",
    journey: "LOGIN",
    operation: "QUICK_LOGIN",
    language: lang,
    extraInfo: [
      {
        key: "ACCOUNT_NUMBER",
        value: number
      },
      {
        key: "ACCOUNT_TYPE",
        value: "MSISDN"
      },
      {
        key: "ID_NUMBER",
        value: idNumber
      },
      {
        key: "NATIONALITY",
        value: nationality
      },
      {
        key: "LOGIN_TYPE",
        value: "QUICK"
      }
    ]
  }
  return api.post(endpoints.CEM_INITIATE_OTP, data, { headers: { 'cem-key': win["cem_key"] } });
  //  return api.get('http://localhost:3001/cemOTPInitiate');
}

const cemSimSwapValidateOtp = (otp: any, refId: any, clientId: any, ClientSecret: any) => {
  let data = {
    operation: "VALIDATE_LOGIN_BY_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: refId
      },
      {
        key: "OTP",
        value: otp
      },
      {
        key: "IS_OAUTH_TOKEN",
        value: "N"
      },
      {
        key: "CLIENT_ID",
        value: clientId
      },
      {
        key: "CLIENT_SECRET",
        value: ClientSecret
      }
    ]
  }
  return api.post(endpoints.CEM_VALIDATE_OTP, data, { headers: { 'cem-key': win["cem_key"] } });
  // return api.get('http://localhost:3001/cemOtpValidate');
}

const cemSimSwapResendOtp = (refId: any, modes: any) => {
  let data = {
    operation: "RESEND_OTP",
    extraInfo: [
      {
        key: "REF_ID",
        value: refId
      },
      {
        key: "MODES",
        value: modes //"SMS,EMAIL"
      }
    ]
  }
  return api.put(endpoints.CEM_RESEND_OTP, data, { headers: { 'cem-key': win["cem_key"] } });
  // return api.get('http://localhost:3001/cemOtpValidate');
}

const getUpdateStatusApi = (apiName: string, res: any) => {
  // console.log(apiName, res.status);
  console.log(apiName, res);
  let data = {
    "apiStatus": `${apiName}-${res}`
  }
  return axios.post(`${serverURL}${updateAPIURL}`, data);
}

const getTCCMappingErrorApi = () => {
  return api.get(endpoints.TCC_ERROR_MAPPING_API);
}

const getAuditServiceSave = (data: any) => {
  return api.post(endpoints.AUDIT_SERVICE_SAVE, data);
}

const reGenerateToken = async () => {
  console.log("reGenerateToken :: Enter");
  console.log("reGenerateTokenUrl => " + serverURL + "" + reGenerateTokenUrl);

  return await fetch(serverURL + reGenerateTokenUrl, {
    method: "GET",
  });
}

export { getProductOfferByID, structure, getCheckoutBySCId, shoppingCart, mapDeliveryCheck, getShoppingCartById, qualifyProds, captData, validateSCart, patchSignature, patchSimType, patchUnpaidBills, patchSecurityDeposit, fetchMsisdn, getTccEligibility, reserveMsisdn, getCustomerRelatedAccount, getUnpaidBills, getDeposit, generateOrder, getSimDetails, tccRegisterApi, getQrCode, getEmailService, getAllPlanDetails, initiateOtp, validateOtp, getAppointments, reserveAppointment, ftthFeasibilityCheck, customerDetailsApi, updateAndValidateShoppingCart, createOrder, fetchOdbDetails, FamilyPlanCheckApi, getExternalId, ValidateSimApi, deliverySendOtp, mnpSendOtp, simSwapSendOtp, deliveryValidateOtp, rSendOtp, mobilyOtpSend, mobilyOtpValidate, mobilyOtpResend, byPassVerification, simSwapResendOtp, paymentInitiateApiCall, eSimValidation, ecomPaymentInitiateApi, cemSimSwapSendOtp, cemSimSwapValidateOtp, cemSimSwapResendOtp, simswapCustomerDetailsApi, simSwapValidateOtp, getUpdateStatusApi, getTCCMappingErrorApi, tccCemBffSendOtp, getAuditServiceSave, retrieveAppointments, ChangeOfProcessContextSC, getMainAndAroundODB, reGenerateToken, ecomEsimPaymentInitiateApi, ivrCallbackStatus };
